import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation, usePermissions } from 'hooks';
import { translations } from './translations';
import {
  PaginateGroupsState,
  PaginateGroupsActions,
} from 'store/ducks/settings/groups';

import { PaginatePermissionsActions } from 'store/ducks/settings/permissions';

import { SelectedFilterActions, SelectedFilterState } from 'store/ducks/filter';

import * as S from './styles';
import { MainContainer, Paginator, MenuSelector } from 'components/shared';
import { GridGroups, FilterGroups } from 'components/settings';

export const ListGroups: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();

  const [query, setQuery] = useState<Record<string, any>>({
    limit: 10,
    page: 1,
  });

  const { loading, pagination, data } = useSelector<
    RootStateOrAny,
    PaginateGroupsState
  >((state) => state.paginateGroups);

  const { data: dataFilter } = useSelector<RootStateOrAny>(
    (state) => state.selectedFilter
  ) as SelectedFilterState;

  const handleSubmitFilter = useCallback(
    (value) => {
      const data = {
        ...dataFilter,
        ...value,
        page: 1,
      };
      dispatch(SelectedFilterActions.success(data));
      setQuery((state) => ({ ...state, data }));
    },
    [setQuery, dispatch, dataFilter]
  );

  const handlePageChange = useCallback(
    (value) => {
      const data = {
        ...dataFilter,
        page: value,
      };
      dispatch(SelectedFilterActions.success(data));
      setQuery((state) => ({ ...state, data }));
    },
    [setQuery, dispatch, dataFilter]
  );

  const getData = useCallback(() => {
    dispatch(PaginateGroupsActions.request({ ...query, ...dataFilter }));
  }, [dispatch, query, dataFilter]);

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    dispatch(PaginatePermissionsActions.reset());
  }, [dispatch]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation('configuracoes')} <MenuSelector page="groups" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission('insertProfileUser') && (
            <S.ButtonMini onClick={() => history.push('/settings/groups/new')}>
              {getTranslation('novoPerfilUsuario')}
            </S.ButtonMini>
          )}
          <FilterGroups onFilter={handleSubmitFilter} />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridGroups groups={data} />
        <Paginator
          pagination={pagination}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
